export function regexEscape(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const doesIncludeCaseInsensitive = (string: string, search: string) => {
  const regex = new RegExp(search, 'i')
  return regex.test(string)
}
